var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 125,
    viewBox: "0 0 124 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.71431,
    height: 8.70439,
    rx: 0.468379,
    transform: "matrix(-0.741516 0.670935 0.670935 0.741516 101.67 114.042)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.875 97.1123L83.5792 107.792L94.5869 120.12C94.9331 120.508 95.5288 120.54 95.9142 120.191L106.13 110.948C106.514 110.601 106.543 110.008 106.196 109.624L94.875 97.1123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3867 80.042L67.8371 93.2067L80.2254 106.929L83.8127 108.026L95.2039 97.5147L94.7776 93.7669L82.3867 80.042Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3867 80.042L67.8371 93.2067L80.2254 106.929L83.8127 108.026L95.2039 97.5147L94.7776 93.7669L82.3867 80.042Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1995 97.51L83.8122 108.026L80.1789 106.878L94.7311 93.7158L95.1995 97.51Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1631 80.5831C82.4062 80.3633 82.5167 80.0324 82.4545 79.7106L82.2305 78.5519C82.1994 78.3909 82.1266 78.2409 82.0193 78.1169L65.7996 59.3605C64.8569 58.2703 63.2423 58.07 62.0618 58.8968L55.3574 63.592C55.2145 63.6921 55.0812 63.8053 54.9592 63.9301L49.4495 69.5703C48.4254 70.6185 48.3788 72.2777 49.3423 73.3818L66.3047 92.8194C66.4409 92.9755 66.6251 93.082 66.8283 93.1223L67.5733 93.27C67.8637 93.3276 68.1642 93.2445 68.3838 93.0459L82.1631 80.5831Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1631 80.5831C82.4062 80.3633 82.5167 80.0324 82.4545 79.7106L82.2305 78.5519C82.1994 78.3909 82.1266 78.2409 82.0193 78.1169L65.7996 59.3605C64.8569 58.2703 63.2423 58.07 62.0618 58.8968L55.3574 63.592C55.2145 63.6921 55.0812 63.8053 54.9592 63.9301L49.4495 69.5703C48.4254 70.6185 48.3788 72.2777 49.3423 73.3818L66.3047 92.8194C66.4409 92.9755 66.6251 93.082 66.8283 93.1223L67.5733 93.27C67.8637 93.3276 68.1642 93.2445 68.3838 93.0459L82.1631 80.5831Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1836 78.3058L82.455 79.7103C82.5172 80.0321 82.4067 80.363 82.1637 80.5828L75.2953 86.7949L68.3844 93.0455C68.1648 93.2441 67.8643 93.3272 67.5739 93.2697L66.5154 93.0598C67.4191 89.759 79.7564 79.6349 82.1836 78.3058Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7994 59.3628C64.8569 58.2715 63.2415 58.0706 62.0604 58.8977L55.3587 63.5909C55.2157 63.691 55.0824 63.8042 54.9604 63.929L49.4575 69.5622C48.4307 70.6133 48.387 72.2781 49.3573 73.3816L52.4314 76.878C56.6458 71.4255 62.0322 66.3407 68.5895 62.5936L65.7994 59.3628Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3016 76.1764L74.9154 70.0874L68.5291 74.1814C66.7051 75.3506 65.0421 76.7536 63.5823 78.3546L58.5219 83.9046L64.1425 90.2278L69.6513 84.2024C70.9702 82.7599 72.4548 81.4782 74.0743 80.384L80.3016 76.1764Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.344 65.872C34.6349 52.7577 29.2487 45.0295 24.1353 31.5565C20.4026 21.7211 19.618 19.2931 17.6983 12.5797C16.8158 9.49345 18.4858 6.2511 21.5087 5.17149L22.6915 4.74908L24.595 4.21372C27.7244 3.33356 31.0019 5.06032 32.0633 8.13301C33.0218 10.9077 34.3997 14.8693 36.3132 20.3154C42.3544 37.5095 52.6219 49.2477 58.1957 55.53L59.6215 56.7186C59.8235 56.887 60.0525 57.0202 60.2988 57.1126L63.6737 58.3782C59.4583 60.2517 51.73 67.2774 48.6856 71.9612L47.8333 68.5522C47.7773 68.3281 47.6884 68.1135 47.5695 67.9153L46.3437 65.8723L46.344 65.872Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.344 65.872C34.6349 52.7577 29.2487 45.0295 24.1353 31.5565C20.4026 21.7211 19.618 19.2931 17.6983 12.5797C16.8158 9.49345 18.4858 6.2511 21.5087 5.17149L22.6915 4.74908L24.595 4.21372C27.7244 3.33356 31.0019 5.06032 32.0633 8.13301C33.0218 10.9077 34.3997 14.8693 36.3132 20.3154C42.3544 37.5095 52.6219 49.2477 58.1957 55.53L59.6215 56.7186C59.8235 56.887 60.0525 57.0202 60.2988 57.1126L63.6737 58.3782C59.4583 60.2517 51.73 67.2774 48.6856 71.9612L47.8333 68.5522C47.7773 68.3281 47.6884 68.1135 47.5695 67.9153L46.3437 65.8723L46.344 65.872Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6837 71.9601C51.7282 67.2763 59.4564 60.2506 63.6718 58.3771L60.2969 57.1115C60.0506 57.0191 59.8216 56.8859 59.6196 56.7175L58.09 55.4424L46.3418 65.8711L47.5676 67.9142C47.6865 68.1123 47.7754 68.327 47.8315 68.5511L48.6837 71.9601Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.148 114.521L100.877 115.672L105.924 121.296C106.097 121.49 106.394 121.505 106.587 121.331L107.163 120.809C107.355 120.636 107.37 120.341 107.198 120.149L102.148 114.521Z",
    fill: "url(#paint0_linear_617_2579)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.875 97.1123L84.2408 107.166C83.8724 107.515 83.848 108.093 84.1856 108.471L94.5869 120.12C94.9331 120.508 95.5288 120.54 95.9142 120.191L106.13 110.948C106.514 110.601 106.543 110.008 106.196 109.624L94.875 97.1123Z",
    fill: "url(#paint1_linear_617_2579)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.875 97.1123L83.5792 107.792L94.5869 120.12C94.9331 120.508 95.5288 120.54 95.9142 120.191L106.13 110.948C106.514 110.601 106.543 110.008 106.196 109.624L94.875 97.1123Z",
    fill: "url(#paint2_linear_617_2579)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3867 80.042L67.8371 93.2067L80.2254 106.929L83.8127 108.026L95.2039 97.5147L94.7776 93.7669L82.3867 80.042Z",
    fill: "url(#paint3_linear_617_2579)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3867 80.042L67.8371 93.2067L80.2254 106.929L83.8127 108.026L95.2039 97.5147L94.7776 93.7669L82.3867 80.042Z",
    fill: "url(#paint4_linear_617_2579)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1995 97.51L83.8122 108.026L80.1789 106.878L94.7311 93.7158L95.1995 97.51Z",
    fill: "url(#paint5_linear_617_2579)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1631 80.5831C82.4062 80.3633 82.5167 80.0324 82.4545 79.7106L82.2305 78.5519C82.1994 78.3909 82.1266 78.2409 82.0193 78.1169L65.7996 59.3605C64.8569 58.2703 63.2423 58.07 62.0618 58.8968L55.3574 63.592C55.2145 63.6921 55.0812 63.8053 54.9592 63.9301L49.4495 69.5703C48.4254 70.6185 48.3788 72.2777 49.3423 73.3818L66.3047 92.8194C66.4409 92.9755 66.6251 93.082 66.8283 93.1223L67.5733 93.27C67.8637 93.3276 68.1642 93.2445 68.3838 93.0459L82.1631 80.5831Z",
    fill: "url(#paint6_linear_617_2579)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1631 80.5831C82.4062 80.3633 82.5167 80.0324 82.4545 79.7106L82.2305 78.5519C82.1994 78.3909 82.1266 78.2409 82.0193 78.1169L65.7996 59.3605C64.8569 58.2703 63.2423 58.07 62.0618 58.8968L55.3574 63.592C55.2145 63.6921 55.0812 63.8053 54.9592 63.9301L49.4495 69.5703C48.4254 70.6185 48.3788 72.2777 49.3423 73.3818L66.3047 92.8194C66.4409 92.9755 66.6251 93.082 66.8283 93.1223L67.5733 93.27C67.8637 93.3276 68.1642 93.2445 68.3838 93.0459L82.1631 80.5831Z",
    fill: "url(#paint7_linear_617_2579)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1836 78.3058L82.455 79.7103C82.5172 80.0321 82.4067 80.363 82.1637 80.5828L75.2953 86.7949L68.3844 93.0455C68.1648 93.2441 67.8643 93.3272 67.5739 93.2697L66.5154 93.0598C67.4191 89.759 79.7564 79.6349 82.1836 78.3058Z",
    fill: "url(#paint8_linear_617_2579)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7994 59.3628C64.8569 58.2715 63.2415 58.0706 62.0604 58.8977L55.3587 63.5909C55.2157 63.691 55.0824 63.8042 54.9604 63.929L49.4575 69.5622C48.4307 70.6133 48.387 72.2781 49.3573 73.3816L52.4314 76.878C56.6458 71.4255 62.0322 66.3407 68.5895 62.5936L65.7994 59.3628Z",
    fill: "#BFBFBF"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3016 76.1764L74.9154 70.0874L68.5291 74.1814C66.7051 75.3506 65.0421 76.7536 63.5823 78.3546L58.5219 83.9046L64.1425 90.2278L69.6513 84.2024C70.9702 82.7599 72.4548 81.4782 74.0743 80.384L80.3016 76.1764Z",
    fill: "url(#paint9_linear_617_2579)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.344 65.872C34.6349 52.7577 29.2487 45.0295 24.1353 31.5565C20.4026 21.7211 19.618 19.2931 17.6983 12.5797C16.8158 9.49345 18.4858 6.2511 21.5087 5.17149L22.6915 4.74908L24.595 4.21372C27.7244 3.33356 31.0019 5.06032 32.0633 8.13301C33.0218 10.9077 34.3997 14.8693 36.3132 20.3154C42.3544 37.5095 52.6219 49.2477 58.1957 55.53L59.6215 56.7186C59.8235 56.887 60.0525 57.0202 60.2988 57.1126L63.6737 58.3782C59.4583 60.2517 51.73 67.2774 48.6856 71.9612L47.8333 68.5522C47.7773 68.3281 47.6884 68.1135 47.5695 67.9153L46.3437 65.8723L46.344 65.872Z",
    fill: "url(#paint10_linear_617_2579)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.344 65.872C34.6349 52.7577 29.2487 45.0295 24.1353 31.5565C20.4026 21.7211 19.618 19.2931 17.6983 12.5797C16.8158 9.49345 18.4858 6.2511 21.5087 5.17149L22.6915 4.74908L24.595 4.21372C27.7244 3.33356 31.0019 5.06032 32.0633 8.13301C33.0218 10.9077 34.3997 14.8693 36.3132 20.3154C42.3544 37.5095 52.6219 49.2477 58.1957 55.53L59.6215 56.7186C59.8235 56.887 60.0525 57.0202 60.2988 57.1126L63.6737 58.3782C59.4583 60.2517 51.73 67.2774 48.6856 71.9612L47.8333 68.5522C47.7773 68.3281 47.6884 68.1135 47.5695 67.9153L46.3437 65.8723L46.344 65.872Z",
    fill: "url(#paint11_linear_617_2579)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6837 71.9601C51.7282 67.2763 59.4564 60.2506 63.6718 58.3771L60.2969 57.1115C60.0506 57.0191 59.8216 56.8859 59.6196 56.7175L58.09 55.4424L46.3418 65.8711L47.5676 67.9142C47.6865 68.1123 47.7754 68.327 47.8315 68.5511L48.6837 71.9601Z",
    fill: "url(#paint12_linear_617_2579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_617_2579",
    x1: 105.593,
    y1: 120.907,
    x2: 106.998,
    y2: 119.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352885,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804367,
    stopColor: "#F4F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_617_2579",
    x1: 89.9024,
    y1: 114.817,
    x2: 101.143,
    y2: 104.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#E6E6E6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#ACABAB",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#C9C9C9",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#888888",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_617_2579",
    x1: 89.0701,
    y1: 102.365,
    x2: 101.02,
    y2: 115.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#A5A0A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_617_2579",
    x1: 74.9135,
    y1: 101,
    x2: 89.4332,
    y2: 87.6513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129972,
    stopColor: "#F5F5F5",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291674,
    stopColor: "#BFBFBF",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459526,
    stopColor: "#E7E7E7",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597024,
    stopColor: "#C0C0C0",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748232,
    stopColor: "#E0E0E0",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889509,
    stopColor: "#C2C2C2",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_617_2579",
    x1: 74.6793,
    y1: 100.063,
    x2: 88.2623,
    y2: 87.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B9B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_617_2579",
    x1: 87.4537,
    y1: 100.295,
    x2: 89.7487,
    y2: 102.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_617_2579",
    x1: 67.6527,
    y1: 93.975,
    x2: 82.4067,
    y2: 80.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#9D9D9D",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#DBDBDB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#7E7E7E",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#CECECE",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#919191",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#D9D9D9",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_617_2579",
    x1: 59.2219,
    y1: 82.9681,
    x2: 74.6784,
    y2: 69.3851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525252",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_617_2579",
    x1: 73.7215,
    y1: 84.9888,
    x2: 75.3298,
    y2: 86.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_617_2579",
    x1: 60.8634,
    y1: 86.4806,
    x2: 77.2566,
    y2: 72.8976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114583,
    stopColor: "#EDEDED",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#CBCBCB",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#E3E3E3",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#C0C0C0",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#E1E1E1",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BDBDBD",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_617_2579",
    x1: 48.9201,
    y1: 45.0296,
    x2: 34.6347,
    y2: 50.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_617_2579",
    x1: 48.9201,
    y1: 45.0296,
    x2: 34.6347,
    y2: 50.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_617_2579",
    x1: 57.1145,
    y1: 62.8267,
    x2: 53.8359,
    y2: 58.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorch);
export default __webpack_public_path__ + "static/media/Torch.33cb5694eae838729030769763c8661f.svg";
export { ForwardRef as ReactComponent };